<template>
  <withTopNav :leftText="$t('meu.Sake')" fixed @clickLeft="
    sharedData.showAmount === 2 || sharedData.showAmount === 3
      ? $router.push('/')
      : $router.back()
  ">
  <div class="saque flex flex-col h-full">
    <div class="flex-1 flex flex-col overflow-y-auto">
      <EnterAmount v-if="sharedData.showAmount === 0" @next="sharedData.showAmount = 1" />
      <EnterMessage
        v-if="sharedData.showAmount === 1"
        @next="sharedData.showAmount = 2"
      />
      <SaqueSuccess v-if="sharedData.showAmount === 2 || sharedData.showAmount === 3" />
    </div>
  </div>
  </withTopNav>
</template>

<script setup lang="ts">
import { getMoney } from "@/api/saque";
import EnterAmount from "./compontents/EnterAmount.vue";
import EnterMessage from "./compontents/EnterMessage.vue";
import SaqueSuccess from "./compontents/SaqueSuccess.vue";
import withTopNav from '@/layouts/withTopNav.vue'

const sharedData = ref<any>({
  amount: null, //提现金额
  showAmount: 0, //提现金额页面
  orderNo: "", //订单号
  totalMoney: 0, //钱包余额
  limitAmount: 0, //打码量
  accountName: "", //姓名
  cpf: "", //身份证
  cpfId: "", //身份证id
  accountEmail: "", //邮箱
  accountMobile: "", //手机号
  accountCnpj: "", //公司名称
  username: "", //用户名
});

provide("sharedData", sharedData);
// 查询钱包可用余额 打码量 以及提现详细信息
const queryMoney = async () => {
  const res = await getMoney();
  if (res.code === 1) {
    sharedData.value.totalMoney = res.data?.balance; // 钱包余额
    const fieldsToUpdate = [
      "limitAmount", // 打码量
      "accountName", // 姓名
      "cpf", // 身份证
      "cpfId", // 身份证id
      "accountEmail", // 邮箱
      "accountMobile", // 手机号
      "accountCnpj", // 公司名称
      "accountEvp", // 公司名称
      "username", // 用户名
      "status", // 状态
    ];
    fieldsToUpdate.forEach((field) => {
      sharedData.value[field] = res.data?.[field];
    });
  }
};
onMounted(() => {
  queryMoney();
});
</script>

<style lang="scss" scoped></style>
